import React from 'react';
import PropTypes from 'prop-types';
import ModalManager from '../elements-modal/modal-manager-v2';
import ModalFlowSteps from '../elements-modal/ModalFlowSteps';
import { defineMessages, injectIntl, intlShape, FormattedMessage } from 'react-intl';

const IBIntroModalFlow = ({ intl, whichModal, ...props }) => {
  const translationMessages = defineMessages({
    introOneHeading: {
      id: 'hosting.ib_intro_modal_flow.grow_business_instant_book_heading',
      defaultMessage: 'Grow your business with Instant Book'
    },
    introOneText: {
      id: 'hosting.ib_intro_modal_flow.grow_business_instant_book_info_text',
      defaultMessage: 'Allow guests to book your space with a single click. Eliminate unnecessary back and forth and increase your bookings.'
    },
    introTwoHeading: {
      id: 'hosting.ib_intro_modal_flow.in_charge_heading',
      defaultMessage: 'You’re in charge'
    },
    introTwoText: {
      id: 'hosting.ib_intro_modal_flow.in_charge_info_text',
      defaultMessage: 'You’ll always have 24 hours of lead time and can cancel penalty free, just make sure your calendar and host rules are up to date.'
    },
    introThreeHeading: {
      id: 'hosting.ib_intro_modal_flow.flip_switch_heading',
      defaultMessage: 'Flip the switch to get started'
    },
    introThreeText: {
      id: 'hosting.ib_intro_modal_flow.flip_switch_info_text',
      defaultMessage: 'Choose which listings to make available for Instant Book. When you do, you’ll be promoted in search with a lightning icon.'
    }
  });

  const syncFlow = [
    {
      id: 'IBIntro1',
      body: {
        image: 'ib-karl',
        heading: intl.formatMessage(translationMessages.introOneHeading),
        infoText: intl.formatMessage(translationMessages.introOneText)
      },
      nextModal: 'IBIntro2'
    },
    {
      id: 'IBIntro2',
      body: {
        image: 'ib-controls',
        heading: intl.formatMessage(translationMessages.introTwoHeading),
        infoText: intl.formatMessage(translationMessages.introTwoText)
      },
      nextModal: 'IBIntro3',
      previousModal: 'IBIntro1'
    },
    {
      id: 'IBIntro3',
      body: {
        image: 'ib-switch',
        heading: intl.formatMessage(translationMessages.introThreeHeading),
        infoText: intl.formatMessage(translationMessages.introThreeText),
        buttonComponent:
          <button
            className="btn btn-primary form flow-cta remove-click-styling"
            onClick={() => { props.toggleModal(''); }}
          >
            <FormattedMessage
              id="hosting.ib_intro_modal_flow.button_text"
              defaultMessage="Get Started"
            />
          </button>
      },
      previousModal: 'IBIntro2'
    }
  ];
  return (
    <ModalManager whichModal={whichModal}>
      {
        syncFlow.map((flow, i) => {
          return (
            <ModalFlowSteps
              addCloseIcon={false}
              key={flow.id}
              id={flow.id}
              length={syncFlow.length}
              index={i}
              {...flow}
              {...props}
            />
          );
        })
      }
    </ModalManager>
  );
};

IBIntroModalFlow.propTypes = {
  selectedSpace: PropTypes.string,
  spaces: PropTypes.array,
  changeModal: PropTypes.func,
  whichModal: PropTypes.oneOf([
    'IBIntro1',
    'IBIntro2',
    'IBIntro3'
  ]),
  toggleModal: PropTypes.func,
  intl: intlShape
};

export default injectIntl(IBIntroModalFlow);
